import { useTheme } from 'styled-components';
export const useMixin = (mixin) => {
    const theme = useTheme();
    // @ts-expect-error Can fail in the migration period. Will eb removed completely afterwards
    return mixin({ theme });
};
//# sourceMappingURL=useMixin.js.map